import {ChargeGroupNamesEnum} from '@spa/api';

import {ConfirmationData} from '../../../app/entries/panel/classes/confirmation-data';

import {PanelAccountsEditFeePlansMessages} from '../../messages';

/**
 * The fee plans page renders one section per charge group returned by `charge/all-charge-groups`,
 * so `ChargeGroupNamesEnum` no longer describes which groups exist - it only names the groups that
 * have a presentation preference below. Groups missing from these descriptors still render, using
 * their own name and the order the endpoint returned them in. Do not reintroduce a hardcoded group
 * list here.
 */

/**
 * Section headings for groups whose name does not read well in the UI. The charge group named
 * `Transaction` has always been shown as `Trade` and is kept that way.
 */
export const FeeGroupLabelOverrides: { [groupName: string]: string } = {
    [ChargeGroupNamesEnum.Transaction]: 'Trade'
};

/**
 * Groups pinned to the top of the page, in this order. Anything else is appended below, keeping the
 * order of the endpoint response.
 */
export const FeeGroupDisplayOrder: string[] = [
    ChargeGroupNamesEnum.Transaction,
    ChargeGroupNamesEnum.Recurring
];

/**
 * Heading for the catch-all section holding fees assigned to a charge group the endpoint no longer
 * returns. Those fees would otherwise be invisible on this page.
 *
 * Deliberately not 'Other': `Other` is a real charge group, so it renders its own section and the
 * two headings would be indistinguishable. Keep this label distinct from every charge group name.
 */
export const FeeGroupUnknownText = 'Unknown Category';

export const ConfirmFeeUnassignmentData = (feeName: string, accountName: string): ConfirmationData => {
    return new ConfirmationData(
        PanelAccountsEditFeePlansMessages.UnAssignFeeConfirmationDialogCaption.message,
        PanelAccountsEditFeePlansMessages.UnAssignFeeConfirmationDialogQuestion.message
            .replace('<<fee>>', '<b>' + feeName + '</b>')
            .replace('<<account>>', '<b>' + accountName + '</b>')
    );
};
